import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { SITE, whatsappLink } from "@/data/site";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative bg-black border-t border-brand-border pt-20 lg:pt-28 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.3em] text-brand-accent mb-4">
              Hotovi začít?
            </div>
            <h2 className="font-display font-black text-5xl lg:text-7xl leading-[0.95] tracking-tight">
              Vaše auto si{" "}
              <span className="italic font-light">zaslouží lepší ráno.</span>
            </h2>
            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href="#reservation"
                data-testid="footer-book-button"
                className="bg-brand-accent text-black font-semibold px-7 py-4 hover:bg-brand-accentHover transition-all"
              >
                Rezervovat termín →
              </a>
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp-button"
                className="px-7 py-4 border border-brand-border hover:border-brand-accent hover:text-brand-accent transition-all"
              >
                WhatsApp {SITE.whatsappNumber}
              </a>
            </div>
          </div>

          <div className="lg:col-span-5 grid sm:grid-cols-2 gap-10 text-sm">
            <div>
              <div className="text-xs uppercase tracking-[0.3em] text-brand-muted mb-4">
                Kontakt
              </div>
              <ul className="space-y-2 text-white/85">
                <li>
                  <a href={`mailto:${SITE.email}`} className="hover:text-brand-accent">
                    {SITE.email}
                  </a>
                </li>
                <li>
                  <a href={whatsappLink()} target="_blank" rel="noreferrer" className="hover:text-brand-accent">
                    {SITE.whatsappNumber}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.3em] text-brand-muted mb-4">
                Pobočky
              </div>
              <ul className="space-y-2 text-white/85">
                {SITE.locations.map((l) => (
                  <li key={l.key}>
                    <span className="block font-medium">Car Spa {l.name}</span>
                    <span className="text-brand-muted text-xs">{l.address}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-brand-border flex flex-wrap items-center justify-between gap-4 text-xs text-brand-muted">
          <div className="flex items-center gap-2">
            <span className="inline-block w-1.5 h-1.5 bg-brand-accent dot-pulse" />
            <span className="font-display font-black tracking-tight uppercase">
              {SITE.brand}
            </span>
            <span>· © {new Date().getFullYear()}</span>
          </div>
          <div className="flex items-center gap-5">
            <span>Ruční detailing v Praze · Čestlice & Butovice</span>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}
              data-testid="footer-cookie-settings"
              className="hover:text-brand-accent transition-colors"
            >
              Nastavení cookies
            </button>
            <Link to="/zasady-cookies" data-testid="footer-cookie-policy" className="hover:text-brand-accent transition-colors">
              Zásady cookies
            </Link>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="inline-flex items-center gap-1.5 border border-brand-border px-3 py-1.5 hover:border-brand-accent hover:text-brand-accent transition-colors"
            >
              <Lock size={11} /> Přihlášení do adminu
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
